export default "__VITE_ASSET__DMFzLzRf__"